/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState, memo } from 'react'

import Nascimento from 'entity/Nascimento';
import DataTable from 'components/DataTable';
import { useAppContext } from 'app/AppContext';

import { usePerfil } from 'useAuth';

import { useNavigate } from 'react-router-dom';

import { Box, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import TextField from '@mui/material/TextField';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { fetchArray } from 'entity';
import { exportAtual, filtro } from 'entity/Nascimento/functions'
import Fazenda from 'entity/Fazenda';

import { useMemo } from 'react';

export default memo(function FazendaForm() {
    const navigate = useNavigate();

    const { useSetTitle, setActionsView } = useAppContext();

    const [options, setOptions] = useState([]);
    const [filteredOptions, setFilteredOptions] = useMemoizedState([]);
    const [searchFazenda, setSearchFazenda] = useState("");
    const [searchMatrizNumero, setSearchMatrizNumero] = useState("");
    const [searchBezerroNumero, setSearchBezerroNumero] = useState("");
    const [searchDataInicial, setSearchDataInicial] = useState("");
    const [searchDataFinal, setSearchDataFinal] = useState("");
    const [searchStatus, setSearchStatus] = useState("")
    const [isLoading, setIsLoading] = useState(false)

    const perfil = usePerfil();

    function useMemoizedState(initialValue) {
        const [state, setState] = useState(initialValue);
        const memoizedState = useMemo(() => state, [state]);

        const setMemoizedState = useCallback((newState) => {
            setState(newState);
        }, []);

        return [memoizedState, setMemoizedState];
    }

    useEffect(() => {
        const actions = [
            {
                uid: "novoForm",
                text: "Novo",
                iconName: "Add",
                sequence: "10",
                action: () => {
                    navigate("/nascimento");
                },
            },
        ];
        // if (!window.cordova) {
        actions.push({
            uid: "Export",
            text: "Exportar",
            iconName: "FileDownload",
            sequence: "9",
            action: () => {
                exportAtual(filteredOptions)
            },
        })
        // }

        setActionsView(actions);

        return () => {
            setActionsView([]);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navigate, setActionsView, filteredOptions]);

    useSetTitle("Nascimentos");

    const loadOptions = useCallback(async () => {
        // Carrega apenas uma vez.
        setIsLoading(true)
        if (options.length === 0) {
            if (perfil) {
                if (perfil.tipoPerfil === "admin") {
                    const result = await fetchArray(Nascimento.getAll());
                    setOptions([...result]);
                    setFilteredOptions([...result]);

                } else {
                    // busca as uid das fazendas cujo usuário tem acesso autorizado
                    let query = await Fazenda.where("perfisAutorizados", "array-contains", perfil.uid);
                    const fazendas = await fetchArray(query.get());
                    let uidFazendas = fazendas.map(f => f.uid)

                    // tras somente os nacimentos das fazendas autorizadas
                    let query2 = await Nascimento.where("fazenda.uid", "in", uidFazendas)
                    const result2 = await fetchArray(query2.get());

                    setOptions([...result2]);
                    setFilteredOptions([...result2]);
                }
            }
        }
        setIsLoading(false)
    }, [options.length, perfil]);


    useEffect(() => {
        loadOptions();
    }, [loadOptions]);

    const onChangeSearchFazenda = e => {
        setSearchFazenda(e.target.value)
    }

    const onChangeSearchMatrizNumero = e => {
        setSearchMatrizNumero(e.target.value)
    }

    const onChangeSearchBezerroNumero = e => {
        setSearchBezerroNumero(e.target.value)
    }

    const onChangeSearchDataInicial = e => {
        setSearchDataInicial(e.target.value)
    }

    const onChangeSearchDataFinal = e => {
        setSearchDataFinal(e.target.value)
    }
    const onChangeSearchStatus = e => {
        setSearchStatus(e.target.value)
    }

    const handleSearch = () => {
        setIsLoading(true)
        setFilteredOptions(
            filtro(options, searchFazenda, searchMatrizNumero, searchBezerroNumero, searchDataInicial, searchDataFinal, searchStatus)
        )
        setIsLoading(false)
    }

    useEffect(() => {
        handleSearch()
        return () => { }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchFazenda, searchMatrizNumero, searchBezerroNumero, searchDataInicial, searchDataFinal, searchStatus])

    // // função para deletar valores, usando algum tipo de filtro
    // // deixei aqui como base para caso necessite futuramente
    // const handleDeleteValues = () => {
    //     const newValues = []
    //     options.forEach((item) => {
    //         let data = new Date(item.data.seconds * 1000)

    //         // const inicioPeriodo = new Date('2023-04-01');
    //         const fimPeriodo = new Date('2023-04-30');

    //         if (data <= fimPeriodo) {
    //             newValues.push(item)
    //         }
    //     })
    //     // newValues.forEach((value) => {
    //     //     Nascimento.delete(value.uid)
    //     // })
    // }

    return (
        <Box sx={{ flex: 1, height: { xs: "100%", sm: "60vh" } }}>
            <Box sx={{ textAlign: "center" }}>
                <Accordion sx={{ boxShadow: 3, mb: 1 }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography>Filtro</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <TextField
                            sx={{ width: "100%", my: 2 }}
                            id="fazendaSearchTextField"
                            label="Fazenda"
                            variant="standard"
                            onChange={onChangeSearchFazenda}
                            value={searchFazenda}
                        />

                        <TextField
                            sx={{ width: "100%", my: 2 }}
                            id="matrizNumeroSearchTextField"
                            label="Número da Matriz"
                            variant="standard"
                            onChange={onChangeSearchMatrizNumero}
                            value={searchMatrizNumero}
                        />

                        <TextField
                            sx={{ width: "100%", my: 2 }}
                            id="bezerroNumeroSearchTextField"
                            label="Número do Bezerro"
                            variant="standard"
                            onChange={onChangeSearchBezerroNumero}
                            value={searchBezerroNumero}
                        />

                        <TextField
                            sx={{ width: "100%", my: 2, }}
                            id="dataInicialSearchTextField"
                            label="Data Inicial"
                            variant="standard"
                            type="date"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={onChangeSearchDataInicial}
                            value={searchDataInicial}
                        />

                        <TextField
                            sx={{ width: "100%", my: 2 }}
                            id="dataFinalSearchTextField"
                            label="Data Final"
                            variant="standard"
                            type="date"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={onChangeSearchDataFinal}
                            value={searchDataFinal}
                        />
                        <FormControl variant="standard" sx={{ width: '100%' }}>
                            <InputLabel id="statusSearchSelectLabel">Status</InputLabel>
                            <Select
                                label="Status"
                                labelId="statusSearchSelectLabel"
                                id="statusSearchSelect"
                                value={searchStatus}
                                onChange={onChangeSearchStatus}
                                sx={{ textAlign: 'left' }}
                            >
                                <MenuItem value="">TODOS</MenuItem>
                                <MenuItem value="ATIVO">ATIVO</MenuItem>
                                <MenuItem value="CANCELADO">CANCELADO</MenuItem>
                            </Select>
                        </FormControl>
                    </AccordionDetails>
                </Accordion>
            </Box>
            {/* <Button onClick={handleDeleteValues} >DELETAR</Button> */}
            {/* <Button onClick={handleLogValues} >LOGS</Button> */}

            <DataTable
                columns={Nascimento.searchColumns}
                rows={filteredOptions}
                loading={isLoading}
                getRowId={(row) => row.uid}
                disableSelectionOnClick
                disableColumnMenu
                hideFooterSelectedRowCount
                disableVirtualization
                initialState={{
                    pagination: {
                        pageSize: 25,
                    },
                }}

                onRowClick={row => navigate("/nascimento?uid=" + row.id)}
                sx={{
                    "& .MuiDataGrid-row:hover": {
                        cursor: "pointer",
                    },
                    '& .MuiDataGrid-row:nth-of-type(odd)': {
                        backgroundColor: "rgba(145, 145, 145, 0.20);",
                    },
                    '& .MuiDataGrid-row:nth-of-type(even)': {
                        backgroundColor: "grey",
                    },
                }}
            />
        </Box>
    )
})
